// import React, { useEffect, useState } from "react";
// import "./Banner.css";

// import Apply_Now_Btn from "../../common/apply-now-btn/Apply_Now_Btn";
// import Download_Btn from "../../common/download-btn/Download_Btn";
// import Apply_Modal from "../../apply-modal/Apply_Modal";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faStar } from "@fortawesome/free-solid-svg-icons";

// import { useDispatch, useSelector } from "react-redux";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, EffectFade, Controller } from "swiper/modules";
// import "swiper/css/effect-fade";

// import { IDS } from "../../../utils/IDS";
// import { AllAppSetup } from "../../../features/admin/common/Slice";

// import "swiper/css";

// function Banner({ all_banner_text, all_home_image }) {
//   const [show, setShow] = useState(false);
//   const [imageLoaded, setImageLoaded] = useState(false);
//   const [downloading, setDownloading] = useState(false);

//   const [textSwiper, setTextSwiper] = useState(null);
//   const [imageSwiper, setImageSwiper] = useState(null);

//   const dispatch = useDispatch();
//   const appsetup = useSelector((state) => state.common.all_app_setup);

//   const brochure = appsetup?.brochure;
//   const bannerSrc = all_banner_text?.banner
//     ? `${IDS.IMG_URL}${all_banner_text.banner}`
//     : null;

//   useEffect(() => {
//     dispatch(AllAppSetup());
//   }, [dispatch]);

//   const handleDownload = () => {
//     if (!brochure) {
//       alert("Brochure PDF is not available");
//       return;
//     }

//     const fullPDFUrl = `${IDS.IMG_URL}${brochure}`;
//     window.open(fullPDFUrl, "_blank");
//   };

//   console.log("all_banner_text:", all_banner_text);
//   console.log("length:", all_banner_text?.length);

//   return (
//     <>
//       <section className="home_banner">
//         <div className="home_banner_image_div container-fluid p-0">
//           {!imageLoaded && <div className="shimmer_loader" />}
//           <img
//             src={bannerSrc}
//             alt={all_banner_text?.name || "Home Banner"}
//             onLoad={() => setImageLoaded(true)}
//             className={`banner_img ${imageLoaded ? "visible" : "hidden"}`}
//           />
//         </div>
//         <div className="container">
//           <div className="banner_content_holder">
//             <div className="left_div">
//               {/* <p className="learn_skill">
//                 Learn Skills <span> that get you</span>
//               </p> */}

//               <Swiper
//                 modules={[Autoplay, Controller]}
//                 onSwiper={setTextSwiper}
//                 controller={{ control: imageSwiper }}
//                 autoplay={{
//                   delay: 3000,
//                   disableOnInteraction: false,
//                   pauseOnMouseEnter: false,
//                 }}
//               >
//                 {all_banner_text?.map((item, index) => (
//                   <SwiperSlide key={index}>
//                     <h5 className="hired_text">{item?.text}</h5>
//                     <h5 className="hired_text">{item?.heading}</h5>
//                     <p className="banner_text">{item?.description}</p>
//                   </SwiperSlide>
//                 ))}
//               </Swiper>

//               {/* <p className="banner_text">
//                 Our courses are designed to help you land your dream job or earn
//                 the raise you deserve. With practical, industry-focused training
//                 and a structured learning approach, you gain the skills
//                 employers actually look for so you can grow confidently and move
//                 ahead in your career.
//               </p> */}

//               <Download_Btn
//                 onClick={handleDownload}
//                 disabled={downloading || !brochure}
//               />
//             </div>

//             <div className="ratings_div">
//               <div className="rating_img">
//                 <img
//                   src="/assets/images/home/banner/group-pic.png"
//                   alt="group"
//                   className="group_pic"
//                 />
//               </div>

//               <div className="ratings_holder">
//                 <FontAwesomeIcon icon={faStar} style={{ color: "#FFC107" }} />
//                 <span className="rating"> 4.8/5</span> Rating Over 2500 Reviews
//               </div>
//             </div>
//           </div>

//           {/* <Swiper
//               modules={[Autoplay, Controller]}
//               onSwiper={setImageSwiper}
//               controller={{ control: textSwiper }}
//               autoplay={{
//                 delay: 3000,
//                 disableOnInteraction: false,
//                 pauseOnMouseEnter: false,
//               }}
//               loop={true}
//               speed={1000}
//               className="right_swiper"
//             >
//               {all_home_image?.map((item, index) => (
//                 <SwiperSlide key={index}>
//                   <div className="right_div">
//                     <div className="right_img_holder">
//                       <img
//                         src={`${IDS.IMG_URL}${item?.image}`}
//                         alt={`banner-${index}`}
//                         className="girl_img"
//                       />
//                     </div>
//                   </div>
//                 </SwiperSlide>
//               ))}
//             </Swiper> */}
//         </div>

//         <Apply_Modal show={show} handleClose={() => setShow(false)} />
//       </section>
//     </>
//   );
// }

// export default Banner;

import React, { useEffect, useState } from "react";
import "./Banner.css";

import Apply_Now_Btn from "../../common/apply-now-btn/Apply_Now_Btn";
import Download_Btn from "../../common/download-btn/Download_Btn";
import Apply_Modal from "../../apply-modal/Apply_Modal";

import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

import { IDS } from "../../../utils/IDS";
import { AllAppSetup } from "../../../features/admin/common/Slice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { ShimmerPostItem } from "react-shimmer-effects";

function Banner({ all_banner_text }) {
  const [show, setShow] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const dispatch = useDispatch();
  const appsetup = useSelector((state) => state.common.all_app_setup);

  const brochure = appsetup?.brochure;

  useEffect(() => {
    dispatch(AllAppSetup());
  }, [dispatch]);

  const handleDownload = () => {
    if (!brochure) {
      alert("Brochure PDF is not available");
      return;
    }

    const fullPDFUrl = `${IDS.IMG_URL}${brochure}`;
    window.open(fullPDFUrl, "_blank");
  };

  const isLoading = !all_banner_text || all_banner_text.length === 0;

  return (
    <>

      <section className="home_banner">

        {isLoading ? (
          // 🔥 SHIMMER UI
          <div style={{ padding: "20px" }}>
            <ShimmerPostItem card title cta />
          </div>
        ) : (
          // ✅ ORIGINAL CONTENT
          <Swiper
            modules={[Autoplay, EffectFade]}
            effect="fade"
            fadeEffect={{ crossFade: true }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            speed={1200}
          >
            {all_banner_text?.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className="banner_bg"
                  style={{
                    backgroundImage: `url(${IDS.IMG_URL}${item?.banner})`,
                  }}
                >
                  <div className="banner_overlay">
                    <div className="container">
                      <div className="banner_content_holder">
                        <div className="left_div">
                          <h5 className="hired_text">{item?.text}</h5>

                          <h5 className="hired_text hired_text2">
                            {item?.heading}
                          </h5>

                          <p className="banner_text">
                            {item?.description}
                          </p>

                          <div className="banner_btn_holder">
                            <Apply_Now_Btn onClick={() => setShow(true)} />
                            <br />
                            <br />
                            <Download_Btn
                              onClick={handleDownload}
                              disabled={downloading || !brochure}
                            />
                          </div>

                          <div className="ratings_div">
                            <div className="rating_img">
                              <img
                                src="/assets/images/home/banner/group-pic.png"
                                alt="group"
                                className="group_pic"
                              />
                            </div>

                            <div className="ratings_holder">
                              <FontAwesomeIcon
                                icon={faStar}
                                style={{ color: "#FFC107" }}
                              />
                              <span className="rating"> 4.8/5</span> Rating Over
                              2500 Reviews
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}

        <Apply_Modal show={show} handleClose={() => setShow(false)} />
      </section>
    </>
  );
}

export default Banner;
